// src/components/list/NotificationTile.tsx

import {
  Avatar,
  AvatarGroup,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  Tooltip,
  useTheme,
} from '@mui/material'
import { useNavigate } from 'react-router-dom'

import { UserPool } from '@/types/domain/user'

import { DDMMYYHHMM, getInitials, userLocales } from '../../api'
import { useUserPool } from '../../hooks'

type Props = {
  notification: any
}

export const NotificationTile = ({ notification }: Props) => {
  const theme = useTheme()
  const primary = theme.palette.primary.main

  const navigate = useNavigate()

  const uPool: UserPool = useUserPool()

  const {
    bcc,
    cc,
    email,
    email_topic,
    from_date,
    to_date,
    id,
    identifier,
    min_threshold,
    max_threshold,
    period,
    sensorName,
    sensor_id,
    image_url,
    name,
    time_sent,
  } = notification

  const SENT_AT = new Date(time_sent).toLocaleString(userLocales, DDMMYYHHMM)

  const bccAvatars = data => (
    <AvatarGroup>
      {data !== null &&
        data.split(',').map((item, key) => {
          let tooltip = item
          let image_url
          let caption = key + 1

          // IF email address in uPool, pimp avatar with picture and first + last name
          const uRecord = uPool.find(
            f => f.attributes.email.toLowerCase() === String(item).toLowerCase()
          )
          if (uRecord) {
            tooltip = `${uRecord.attributes.firstname} ${
              uRecord.attributes.lastname
            }`
            if (uRecord.attributes.image_url)
              image_url = uRecord.attributes.image_url

            caption = getInitials(tooltip)
          }

          return (
            <Tooltip key={item} title={tooltip}>
              <Avatar
                src={image_url}
                sx={{ bgcolor: uRecord ? primary : '#666' }}
              >
                {caption}
              </Avatar>
            </Tooltip>
          )
        })}
    </AvatarGroup>
  )

  return (
    <ListItemButton onClick={() => navigate(`/notifications/${id}/edit`)}>
      <ListItemAvatar>
        <Tooltip title={`Alert ID: ${id}`}>
          <Avatar src={image_url} sx={{ width: 40, height: 40 }} />
        </Tooltip>
      </ListItemAvatar>
      <ListItemText primary={`Gebäude`} secondary={name} />
      <ListItemText primary={`Sensor: ${sensorName}`} secondary={sensor_id} />
      <ListItemText primary={`Topic`} secondary={email_topic} />
      <ListItemText primary={`Identifier`} secondary={identifier} />
      <ListItemText primary={`Period`} secondary={period} />
      <ListItemText
        primary={'Threshold'}
        secondary={`min:${min_threshold || ''} | max:${max_threshold || ''}`}
      />
      <ListItemText primary={'from'} secondary={from_date} />
      <ListItemText primary={'to'} secondary={to_date} />
      <ListItemText primary={'Empfänger'} secondary={bccAvatars(email)} />
      <ListItemText primary={`CC`} secondary={bccAvatars(cc)} />
      <ListItemText primary={`BCC`} secondary={bccAvatars(bcc)} />
      <ListItemText primary={`gesendet`} secondary={SENT_AT} />
    </ListItemButton>
  )
}
